module.exports = __webpack_public_path__ + "img/reni-peti.041315d6.jpg";